import {
    ErrorIcon,
    mergeClasses,
    Text,
    Tile,
    TilesSection,
    useAsyncEffect,
    useStatsTileStyles,
    useTileStyles,
} from "@relode/core";
import * as React from "react";

import { useJobContext } from "../../../_infra";

export const JobStats = () => {
    const classes = mergeClasses(useStatsTileStyles({}), useTileStyles({}));

    const statusTile = {
        root: classes.statusTile,
        title: classes.statusTitle,
        content: classes.statusContent,
        paper: classes.tilePaper,
    };

    const {
        state: {
            ui: { isJobLoading, isJobStatsLoading, jobStatsError },
            data: { currentJobId, job },
        },
        actions,
    } = useJobContext();

    const jobStats = job?.jobStats;

    useAsyncEffect(async () => {
        await actions.loadJobStats(currentJobId);
    }, [currentJobId]);

    const displayStat = (
        value: number | undefined | null,
        formattedString: string
    ) => {
        if (value === undefined || value === null) return "n/a";
        return formattedString;
    };

    const getErrorTitleAdornment = () =>
        !!jobStatsError ? <ErrorIcon /> : null;

    const getErrorTooltip = () =>
        !!jobStatsError
            ? jobStatsError.friendlyMessages ??
              "An unexpected error occurred.  Please try again."
            : null;

    const isBusy = isJobLoading || isJobStatsLoading;

    return (
        <div>
            <div className={classes.sectionTitleFlex}>
                <Text variant="h2">job</Text>
                <Text variant="body2" className={classes.statsSyncDate}>
                    data updated nightly
                </Text>
            </div>
            <TilesSection
                usePaper={false}
                classes={{ paper: classes.tilesSectionPaper }}
                className={classes.tilesSection}
            >
                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="avgTimeToHire"
                    title="time to hire"
                    isBusy={isBusy}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(
                        jobStats?.avgFirstHireTimeInDays,
                        `${jobStats?.avgFirstHireTimeInDays} days`
                    )}
                </Tile>

                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="avgTimeToSub"
                    title="time to submit"
                    isBusy={isBusy}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(
                        jobStats?.avgFirstSubmitTimeInDays,
                        `${jobStats?.avgFirstSubmitTimeInDays} days`
                    )}
                </Tile>

                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="inSub"
                    title="in submitted"
                    isBusy={isBusy}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(
                        jobStats?.avgTimeInSubmittedInDays,
                        `${jobStats?.avgTimeInSubmittedInDays} days`
                    )}
                </Tile>

                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="subToInterview"
                    title="sub to interview"
                    isBusy={isBusy}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(
                        jobStats?.submittedToInterviewingPercentage,
                        `${jobStats?.submittedToInterviewingPercentage}%`
                    )}
                </Tile>

                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="interviewToHire"
                    title="interview to hire"
                    isBusy={isBusy}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(
                        jobStats?.interviewingToHiredPercentage,
                        `${jobStats?.interviewingToHiredPercentage}%`
                    )}
                </Tile>

                <Tile
                    small
                    useSubTitle
                    classes={statusTile}
                    id="attritionRate"
                    title="attrition rate"
                    isBusy={isBusy}
                    titleAdornment={getErrorTitleAdornment()}
                    tooltip={getErrorTooltip()}
                >
                    {displayStat(
                        jobStats?.hiredToRejectedPercentage,
                        `${jobStats?.hiredToRejectedPercentage}%`
                    )}
                </Tile>
            </TilesSection>
        </div>
    );
};
